// extracted by mini-css-extract-plugin
module.exports = {"container":"Info_container__21jwt","title":"Info_title__17VK_","service-logo":"Info_service-logo__MsGwf"};